// import 'animate.css';
// import Swiper, {Navigation} from 'swiper';
// import 'swiper/css';
// import 'swiper/css/navigation';
import './scss/block_3.scss';
import dndPromotion from '../main/js/promotion2.js';

class Core {
  constructor() {
    this.currentTimeout = null;
  };
  wait(timeout) {
    if (this.currentTimeout) {
      clearTimeout(this.currentTimeout);
    };
    return new Promise(resolve => {
      this.currentTimeout = setTimeout(resolve, timeout);
    });
  };
};

let globalCount;
async function animationRandom(count, elementResult) {
  const listItem = $('.effect__item');
  listItem.removeClass('active');

  if (globalCount < 1) {
    const getItemResult = listItem.filter(function () {
      return $(this).data('stt') === parseInt(elementResult);
    });
    $(getItemResult).addClass('active');
    return;
  };
  globalCount = count - 1;

  const randomNumber = Math.floor(Math.random() * listItem.length) + 1;
  const target = $(listItem[randomNumber]);
  target.addClass('active');
  await new Core().wait(350);
  animationRandom(globalCount, elementResult);
};


window.addEventListener("load", function () {
  dndPromotion({
    url: prodTemplate.url,
    debug: prodTemplate.debug,
    directory: prodTemplate.directory,
    items: prodTemplate.items,
    names: prodTemplate.names,
    config: {
      timeWait: 4500,
    },
    animResult: function (listPrize) {
      var displayPrize = listPrize[0];
      var prizeIndex = displayPrize.indexImg;
      animationRandom(10, prizeIndex);

    },
    callback: function () {
      if (!this.debug) LuckyDrawExchangeModule.fetchViewData();
      globalCount = 10;
      const listItem = $('.effect__item');
      listItem.removeClass('active');
    },
  });


});